import WarningBar from "./warning_bar";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { SendVerificationEmailManager } from "../../../action_managers/email_verification";
import { fetchSubscriptionForUser } from "../../../action_managers/subscriptions";

function mapStateToProps(state) {
  return {
    user: state.user.user,
    shows: state.shows.shows,
    importJobs: state.user.importJobs,
    subscriptions: state.subscriptions?.subscriptions ?? {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchSubscriptionForUser,
    sendVerificationEmail: user => {
      return dispatch(
        new SendVerificationEmailManager({
          user,
        }).run()
      );
    },
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WarningBar));
